import { createStateSelectorHook } from 'src/lib/sweetState';
import { CustomModelsStore, PerformanceStore } from 'src/store';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['completionPercentMap']);

const useCustomModelsState = createStateSelectorHook(CustomModelsStore, ['runningCustomModels']);

export const useViewState = () => {
  const { completionPercentMap } = usePerformanceState();
  const { runningCustomModels } = useCustomModelsState();

  return {
    completionPercentMap,
    runningCustomModels,
  };
};
